import moment from 'moment'
import 'moment/locale/es';
import {DESC_SMALL_DATETIME_FORMAT} from '../constants/date-time-formats'

export default (date, format = DESC_SMALL_DATETIME_FORMAT, addHour = 0) => date ? moment(date).locale('es').add(addHour, 'hours').format(format) : '';